export const mod10 = (number: string) => {
    if (typeof number !== 'string') return false;
    let len = number.length,
        bit = 1,
        sum = 0,
        val: any,
        weights = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];

    while (len) {
        val = parseInt(number.charAt(--len), 10);
        sum += (bit ^= 1) ? weights[val] : val;
    }
    return sum && sum % 10 === 0;
};


export const mod11 = (number: string) => {
    if (typeof number !== 'string') return false;    
    let len = number.length,
        sum = 0, val: any,
        weights = [1, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
    let arr = weights.splice(weights.length - len, weights.length - (weights.length - len));

    while (len) {
        val = parseInt(number.charAt(--len), 10);
        sum += arr[len] * val;
    }
    return sum && sum % 11 === 0;
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/validation/util/checksum.ts
 **/